import React, { useMemo } from "react";

import { RawFile } from "@mapmycustomers/shared/types/File";
import { useNonNullableContext } from "@mapmycustomers/shared/util/react";

import LockedFiles from "@app/component/createEditEntity/Activity/component/LockedFormFields/LockedFiles";

import CreateEmailContext from "../CreateEmailContext";

interface FileProps {
  required?: boolean;
}

const Files: React.FC<FileProps> = ({ required }) => {
  const { attachedFiles } = useNonNullableContext(CreateEmailContext);

  const files = useMemo(
    () =>
      attachedFiles.reduce<RawFile[]>(
        (result, { file }) => [...result, ...(file ? [file] : [])],
        []
      ),
    [attachedFiles]
  );

  return <LockedFiles files={files} required={required} />;
};

export default Files;
